import gql from 'graphql-tag'
import { fragSeoPostYoastFragment } from '../fragments/seo.js'
import { fragPostContent, fragPostNextPrev } from '../fragments/post.js'
import { fragCptAdv } from '../fragments/advertising.js'
import { fragAuthorSummary } from '../fragments/author.js'
import { fragRedirection } from '../fragments/redirect.js'

export const queryPost = gql`
  ${fragSeoPostYoastFragment}
  ${fragPostContent}
  ${fragAuthorSummary}
  ${fragRedirection}
  query QueryPost($slug: String) {
    postBy(slug: $slug) {
      ...FragPostContent
      hreflang {
        url
        lang
      }
      author {
        node {
          ...FragAuthorSummary
        }
      }
      featuredImage {
        node {
          sourceUrl
          srcSet
          sizes
          mediaDetails {
            height
            width
          }
        }
      }
      seo {
        ...FragSeoPostYoastFragment
      }
    }
    redirects {
      ...FragRedirection
    }
  }
`

export const queryPostIntegration = gql`
  ${fragSeoPostYoastFragment}
  ${fragPostContent}
  ${fragAuthorSummary}
  ${fragRedirection}
  ${fragCptAdv}
  query QueryPostIntegration($slug: String) {
    postBy(slug: $slug) {
      id
      ...FragPostContent
      hreflang {
        url
        lang
      }
      author {
        node {
          ...FragAuthorSummary
        }
      }
      featuredImage {
        node {
          sourceUrl
          srcSet
          sizes
          mediaDetails {
            height
            width
          }
        }
      }
      seo {
        ...FragSeoPostYoastFragment
      }
      advertising {
        acfAdv {
          ... on Advertising {
            advertisingType {
              cptAdv {
                ...FragCptAdv
              }
            }
          }
        }
      }
    }
    redirects {
      ...FragRedirection
    }
  }
`

/*
export const queryPostIntegration = gql`
  ${fragCptAdv}
  query QueryPostIntegration($slug: String) {
    postBy(slug: $slug) {
      id
      advertising {
        acfAdv {
          ... on Advertising {
            advertisingType {
              cptAdv {
                ...FragCptAdv
              }
            }
          }
        }
      }
    }
  }
`
*/

export const queryPrevNextPost = gql`
  ${fragPostNextPrev}
  query QueryPrevNextPost($id: ID) {
    postBy(id: $id) {
      next {
        ...FragPostNextPrev
      }
      previous {
        ...FragPostNextPrev
      }
    }
  }
`
